export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10126.6a3d1951.jpg";